import Link from 'next/link';
import Image from 'next/image';

import { ArrowRight } from '@/icons/index';

import styles from './block-link.module.scss';

const BlockLink = ({ href, icon, alt, ...restProps }) => {
  return (
    <Link href={href} itemScope itemType='https://schema.org/Property'>
      <a title={'Bakcell'} aria-label='Bakcell' className={styles.link}>
        <div className={styles.content}>
          <div className={styles.icon}>
            <Image src={icon} alt={alt} loading='lazy' layout='fill' />
          </div>
          {restProps.children}
        </div>
        <ArrowRight className={styles.arrow} />
      </a>
    </Link>
  );
};

export default BlockLink;
